import OfferForm from './OfferForm';

const Offer = props => {
  return (
    <div id="black-offer" className="bg-[#000000] py-[48px]">
      <div className="container">
        <div className="flex lg:flex-row flex-col md:gap-[76px] gap-[48px] items-center">
          <div className="flex flex-col gap-[16px]  max-w-[360px] w-full">
            <h2 className="md:text-[48px] text-[32px] font-[500] md:leading-[58px] leading-[39px] text-[#9EBF91]">Get a proposal now</h2>
            <p className="text-[18px] text-white leading-[22px]">
              Fill in the form to get a personalized media plan with forecast conversions within 24 hours.
            </p>
          </div>
          <div className="max-w-[648x] w-full flex-1 relative">
            <OfferForm country={props.country} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Offer;
